import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  table: {
    display: 'flex',
    flexDirection: 'column',
  },
  tableRow: {
    display: 'flex',
    '&$hover:hover': {
      boxShadow: `5px 2px 15px ${theme.palette.action.focus}`,
      backgroundColor: 'transparent',
    },
  },
  hover: {},
  tableCell: {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
  },
  penultimateCell: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  hide: {
    display: 'none',
  },
}));

export default styles;
